import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CrossSmall from 'jl-design-system/elements/icons/CrossSmall';

import styles from './typeahead-overlay.scss';

const TypeaheadOverlay = ({ isTypeaheadOpen, onCloseButtonClick }) => {
  const transparentOverlayClasses = classNames(styles.transparentOverlay, {
    [styles.transparentOverlay__hidden]: !isTypeaheadOpen,
  });
  const whiteOverlayClasses = classNames(styles.whiteOverlay, {
    [styles.whiteOverlay__hidden]: !isTypeaheadOpen,
  });
  const closeButtonClasses = classNames(styles.closeButton, {
    [styles.closeButton__hidden]: !isTypeaheadOpen,
  });

  return (
    <>
      <div className={transparentOverlayClasses} />
      <div className={whiteOverlayClasses} />
      <button
        data-testid="close-expanded-search"
        className={closeButtonClasses}
        onClick={onCloseButtonClick}
      >
        <CrossSmall className={styles.closeIcon} />
        <p>Close</p>
      </button>
    </>
  );
};

TypeaheadOverlay.propTypes = {
  isTypeaheadOpen: PropTypes.bool.isRequired,
  onCloseButtonClick: PropTypes.func.isRequired,
};

export default TypeaheadOverlay;
